import { Props as PropertyStatusWidgetProps } from '@tophap/widgets/dist/components/PropertyStatus'
import { googleMapKey } from '#/configs'
import { accessToken, mapStyleId } from '#/configs/mapbox'

export function status(property: TopHap.Property): PropertyStatusWidgetProps['status'] {
  const rawStatus = property.StandardStatus ?
    property.StandardStatus :
    property.TophapStatus

  if (rawStatus === 'Active') {
    if (property.isListHub) {
      return 'Active'
    }
    return property.RentFlag ? 'For Rent' : 'Active'
  } else if (property.TophapStatus === 'PrivateSale') {
    return 'Off-Market'
  } else if (property.TophapStatus === 'Sold') {
    return property.RentFlag ? 'Rented' : 'Sold'
  }

  // return rawStatus
  if (rawStatus === 'PrivateSale') {
    return 'Off-Market'
  }
  return rawStatus
}

export function viewUrl(id: string, address: TopHap.Address) {
  const addressString = `${address.StreetNumber} ${
    address.StreetDirPrefix || ''
  } ${address.StreetName} ${address.UnitNumber || ''} ${address.City} ${
    address.StateOrProvince
  } ${address.PostalCode}`
  return `/homes/details/${addressString.replace(/\/+/g, '-')}/${id}`
    .replace(/#/g, '')
    .replace(/\s+/g, '-')
}

export function viewAppUrl(id: string, address: TopHap.Address) {
  return `${viewUrl(id, address).replace(/homes/, 'app')}?onBack=toFavorites`
}

export function viewUrlFromPlace(place: TopHap.Place) {
  return `/homes/details/${place.place_name
    .toUpperCase()
    .replace(/\s/g, '-')
    .replace(/#|,/g, '')}/${place.id}`
}

export const getStreetImage = async (property: TopHap.Property, width = 450, height = 300) => {
  const status = await fetch(
    `https://maps.googleapis.com/maps/api/streetview/metadata?location=${encodeURIComponent(
      property.address.FullAddress
    )}&key=${googleMapKey}`
  ).then(res => res.json())
    .then(res => res.status)
    .catch(console.error)
  if (status === 'OK') {
    return `https://maps.googleapis.com/maps/api/streetview?size=${width}x${height}&location=${encodeURIComponent(
      property.address.FullAddress
    )}&key=${googleMapKey}`
  } else {
    return undefined
  }
}

export const getPropertyMedia = async (item: TopHap.Property) => {
  const { media } = item
  if (media && media.photos && media.photos.length) {
    return media
  } else {
    let photos = []
    const streetImgae = await getStreetImage(item)
    if (streetImgae) {
      photos = [streetImgae]
    } else {
      photos = [
        `https://api.mapbox.com/styles/v1/tophapinc/${mapStyleId.satellite}/static/${item.location[0]},${item.location[1]},18,0,0/640x480@2x?access_token=${accessToken}`
      ]
    }

    return {
      photos,
      count: 1
    }
  }
}

export function getNeighborhood(
  zones: TopHap.Property['zones'],
  level: number
): Pick<TopHap.ZoneSource, 'id' | 'name' | 'type' | 'level' | 'group'> | undefined {
  if (!zones) return undefined
  const neighborhood = zones.find(e => e.type === 'neighborhood' && e.level <= level)
  return neighborhood || zones.find(e => e.type === 'city' || e.type === 'zip')
}

export function getPinName(property: TopHap.Property) {
  if (property.TophapStatus === 'Active' && property.isNew) {
    return 'active-new'
  } else if (property.TophapStatus === 'PrivateSale') {
    return 'inactive'
  } else {
    return property.TophapStatus.toLowerCase()
  }
}
